<template>
  <div
    :class="$style.wrapper"
    @mouseover="mouseover = true"
    @mouseleave="mouseover = false"
  >
    <slot />
    <MaskCoverPresenter
      :show="mouseover && canScrollLeft"
      :external-style="externalStyle"
      left

      data-event-type="ui_event"
      data-event-action="click-button"
      data-event-item-class="ui/collection-carousel/arrow"
      data-event-label="left"

      @click="progressCalculator.moveLeft"
    />
    <MaskCoverPresenter
      :show="mouseover && canScrollRight"
      :external-style="externalStyle"
      right

      data-event-type="ui_event"
      data-event-action="click-button"
      data-event-item-class="ui/collection-carousel/arrow"
      data-event-label="right"

      @click="progressCalculator.moveRight"
    />
  </div>
</template>

<script lang="ts">
import Vue, { PropType, Component } from 'vue';
import { Nullable } from '@/scripts/models/utility-types';
import MaskCoverPresenter from './mask-cover-presenter.ts.vue';
import { useProgressCalculator } from './mask-controller-progress-calculator';

export default Vue.extend({
  components: {
    MaskCoverPresenter,
  },
  props: {
    collectionPresenter: {
      type: Object as PropType<Component>,
      default: null,
    },
    externalStyle: {
      type: Object as PropType<Record<string, string | undefined>>,
      default: (): any => ({}),
    },
  },

  data() {
    return {
      mouseover: false,
      component: null as Nullable<Component>,
      progress: 0,
      progressCalculator: useProgressCalculator(),
    };
  },

  computed: {
    canScrollLeft(): boolean {
      if (!this.progressCalculator.isScrollable) return false;

      return this.progressCalculator.progress > 0;
    },
    canScrollRight(): boolean {
      if (!this.progressCalculator.isScrollable) return false;

      return this.progressCalculator.progress < 1;
    },
  },

  mounted(): void {
    this.$watch(() => this.collectionPresenter, (component: Nullable<Component>): void => {
      if (component == null) {
        this.progressCalculator.unregisterEvent();
      } else {
        this.progressCalculator.registerEvent(component);
      }
    });
  },
});
</script>

<style module lang="scss">
.wrapper {
  position: relative;
}
</style>
